import { INAMES, LAYER_IMGS } from "../../../constants/items";
import type { AvatarLayers } from "../types/leagueDuel";

// ─── Stuff aléatoire des bots ─────────────────────────────────────────────────
// Habille un bot avec des calques d'équipement au hasard, pour ne pas affronter
// un personnage "nu". La rareté monte légèrement avec l'ELO du bot.
// TODO League : remplacer par le vrai inventaire/équipement de l'adversaire.

const LAYER_SLOTS: (keyof AvatarLayers)[] = ["ball", "familiar", "shoes", "top", "head"];

function pickRarity(elo: number, rng: () => number): string {
  // Plus l'ELO est haut, plus on tire vers rare/epic/ultra.
  const r = rng() + (elo - 100) / 2000; // décalage doux selon l'ELO (départ 100)
  if (r > 0.9) return "ultra";
  if (r > 0.65) return "epic";
  if (r > 0.35) return "rare";
  return "commun";
}

/** Retourne un nom d'item habillable pour un slot donné (avec image de calque). */
function randomItemName(slot: string, elo: number, rng: () => number): string | null {
  const byRarity = INAMES[slot];
  if (!byRarity) return null;
  // On essaie la rareté visée puis on retombe sur n'importe quel nom dispo.
  const order = [pickRarity(elo, rng), "epic", "rare", "commun", "ultra"];
  for (const rar of order) {
    const names = (byRarity[rar] || []).filter((n) => LAYER_IMGS[n]);
    if (names.length) return names[Math.floor(rng() * names.length)];
  }
  return null;
}

/** Construit un set de calques aléatoire pour un bot d'ELO donné. */
export function randomBotLayers(elo: number, rng: () => number = Math.random): AvatarLayers {
  const layers: AvatarLayers = {};
  for (const slot of LAYER_SLOTS) {
    // ~75% de chance d'avoir un item par slot (pas toujours tout équipé).
    if (rng() < 0.75) {
      const name = randomItemName(slot, elo, rng);
      if (name) layers[slot] = LAYER_IMGS[name];
    }
  }
  return layers;
}
